import { PagedResultGeneric } from '../../shared/model/paged-result.model';
import { PagedSearch } from '../../shared/model/paged-search.model';
import { ApiService } from '../../shared/api/api.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CertificationActivitySourceService {
  public constructor(private _apiService: ApiService) {}

  public getAllSources() {
    const search = new PagedSearch();
    search.PageSize = 1000;

    return this._apiService.getPaged('Certifications/Activities/Sources', search);
  }
}
